export const OrderStatusTypes = {
  CREATED: 1,
  PROCESSED: 2,
  COMPLETED: 3,
  CANCELED: 4,
  CUSTOM: 5,
  client: {
    1: { label: 'Создан', colorClass: 'status-created' },
    2: { label: 'Принят', colorClass: 'status-processed' },
    3: { label: 'Выполнен', colorClass: 'status-completed' },
    4: { label: 'Отменён', colorClass: 'status-canceled' },
  },
  provider: {
    1: 'новый',
    2: 'принят',
    3: 'выполнен',
    4: 'отменен',
  },
}

export const CUSTOM_ORDER_STATUS_MAX = 10

export function encodeCustomOrderStatus(slotId) {
  return OrderStatusTypes.CUSTOM * 10 + Number(slotId)
}

export function decodeCustomOrderStatus(statusId) {
  const n = Number(statusId)
  if (!Number.isFinite(n)) return null
  if (Math.floor(n / 10) !== OrderStatusTypes.CUSTOM) return null
  const slot = n % 10
  if (slot < 0 || slot >= CUSTOM_ORDER_STATUS_MAX) return null
  return slot
}

export function isEncodedCustomOrderStatus(statusId) {
  return decodeCustomOrderStatus(statusId) !== null
}

export function sortCustomOrderStatuses(list) {
  return [...(list || [])].sort(
    (a, b) => Number(a?.statusId) - Number(b?.statusId)
  )
}

export function getProviderStatusLabel(statusId, customStatuses = []) {
  const slot = decodeCustomOrderStatus(statusId)
  if (slot !== null) {
    const found = (customStatuses || []).find(
      (item) => Number(item?.statusId) === slot
    )
    return found?.name ?? `этап ${slot}`
  }
  return OrderStatusTypes.provider[statusId] ?? `Статус ${statusId}`
}

export function buildStatusFilterOptions(customStatuses = []) {
  const customOptions = sortCustomOrderStatuses(customStatuses).map((item) => ({
    id: encodeCustomOrderStatus(item.statusId),
    label: item.name,
  }))
  return [
    { id: OrderStatusTypes.CREATED, label: 'новое' },
    { id: OrderStatusTypes.PROCESSED, label: 'принят' },
    ...customOptions,
    { id: OrderStatusTypes.COMPLETED, label: 'выполнено' },
    { id: OrderStatusTypes.CANCELED, label: 'отменено' },
  ]
}

export function statusBadgeClassName(baseClass, statusId) {
  if (isEncodedCustomOrderStatus(statusId)) {
    return `${baseClass} ${baseClass}--custom`
  }
  return `${baseClass} ${baseClass}--${statusId}`
}
